<!-- @format -->

<ng-container *ngIf="productId">
  <sis-button *ngIf="isAdditionVisible$ | async" (clicked)="addToCart()" [disabled]="requestInProgress$ | async" data-cy="add-to-cart">
    {{ "OPEN_UNIVERSITY.STUDY_OFFERING.ADD_TO_CART" | translate }}
  </sis-button>
  <sis-button
    *ngIf="isDeletionVisible$ | async"
    (clicked)="removeFromCart()"
    [disabled]="requestInProgress$ | async"
    [hollow]="true"
    data-cy="remove-from-cart">
    <sis-icon icon="delete" color="primary"></sis-icon>
    {{ "OPEN_UNIVERSITY.STUDY_OFFERING.REMOVE_FROM_CART" | translate }}
  </sis-button>
</ng-container>
